import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BranchesLiteApiService } from '../branches/branches-lite.service';
import { CompanyMessagesModel }   from '../companies/models/company.messages';
import { MessagesService }        from '../messages/messages.service';
import { MessengerService }       from '../messages/messenger/messenger.service';
import { PartstechService }       from '../partstech/partstech.service';
import { UKPostcodeService }      from '../uk-postcode/uk-postcode.service';
import { VendorModel }            from './models/vendor';

@Injectable()
export class VendorIntegrationsService {
  branchInvoices  : Record<string, unknown>[] = [];
  branchPayments  : Record<string, unknown>[] = [];

  private companyMessages : CompanyMessagesModel;
  private vendor          : VendorModel;

  constructor (
    private branchesApi      : BranchesLiteApiService,
    private messagesService  : MessagesService,
    private messengerService : MessengerService,
    private partstechApi     : PartstechService,
    private translateService : TranslateService,
    private ukPostcodeApi    : UKPostcodeService
  ) {}

  init (options: { vendor: VendorModel; companyMessages: CompanyMessagesModel; isBranchVendor: boolean }) {
    this.vendor          = options.vendor;
    this.companyMessages = options.companyMessages;

    if (options.isBranchVendor) {
      this.branchesApi.getVendorPayments(this.vendor)
        .then(payments => this.branchPayments = payments)
        .catch(err => this.messagesService.error(err));

      this.branchesApi.getVendorInvoices(this.vendor)
        .then(invoices => this.branchInvoices = invoices)
        .catch(err => this.messagesService.error(err));
    }
  }

  isPartstechVendor () {
    return this.partstechApi.isPartstechVendor(this.vendor);
  }

  searchUKPostcode () {
    this.ukPostcodeApi.search(this.vendor.postcode)
      .then(data => {
        this.vendor.address1  = data.Premises;
        this.vendor.address2  = data.Street;
        this.vendor.suburb    = data.PostTown;
        this.vendor.postcode  = data.Postcode;
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.UPDATED.SUPPLIER_ADDRESS'), 'success');
      })
      .catch(err => this.messagesService.error(err));
  }

  sendEmail () {
    this.messengerService.email({
      name            : this.vendor.company_name,
      email_address   : this.vendor.email,
      body            : this.companyMessages?.supplier_email_message,
      attachment_type : 5,
      vendor_id       : this.vendor.id
    }).then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success'));
  }
}
